import React, { useEffect, useRef, useState } from 'react';
import { GET_COLLECTION_AGGREGATE_DATA } from '../../api';
import { capitalize } from "../../utils/capitalize";
import moment from "moment/moment";
import cogoToast from "cogo-toast";
import {opportunity, applicant, applicantStats} from "../../api/app";
import $ from "jquery";
import formatNumber from "../../utils/formatNumber";

let searchableFields = [
    { field: 'user.name', isNumeric: false },
    { field: 'user.mobile_number', isNumeric: true }
];

let filter = {};

const Applicant = (props) => {
    document.title = "Applicant";

    const token = localStorage.getItem('jwtToken');
    const [selected, setSelected] = useState(null);
    const [reset, setReset] = useState(new Date().getTime());
    const datatableRef = useRef(null);
    const id = props.match.params.id;

    filter = {
        opportunity: `ObjectId(${id})`
    };

    useEffect(() => {
        applicantStats(id).then((response) => {
            if(!response.error) {
                $('#total-count').text(formatNumber(response.payload?.total_count, "digit"));
                $('#total-approved').text(formatNumber(response.payload?.total_approved, "digit"));
                $('#total-rejected').text(formatNumber(response.payload?.total_rejected, "digit"));
            }
        });
    }, [reset]);

    // ─── View click handler via event delegation ──────────────────────────────
    useEffect(() => {
        const handler = (e) => {
            const btn = e.target.closest('.applicant-view-btn');
            if (!btn) return;

            e.preventDefault();
            e.stopPropagation();

            try {
                const encoded = btn.getAttribute('data-row');
                const row = JSON.parse(decodeURIComponent(escape(atob(encoded))));
                setSelected(row);

                const el = document.getElementById("view-modal");
                if (!el) return;
                let modal = window.KTModal?.getInstance(el);
                if (!modal) modal = new window.KTModal(el);
                modal.show();

                // Init tabs after modal is visible
                setTimeout(() => {
                    if (window.KTTabs?.createInstances) {
                        window.KTTabs.createInstances();
                    }
                }, 100);
            } catch (err) {
                console.error("Failed to parse row data:", err);
            }
        };

        document.addEventListener('click', handler);
        return () => document.removeEventListener('click', handler);
    }, []);

    const closeViewModal = () => {
        const el = document.getElementById("view-modal");
        if (!el) return;
        let modal = window.KTModal?.getInstance(el);
        if (!modal) modal = new window.KTModal(el);
        modal.hide();
        setSelected(null);
    };

    // ─── Datatable ────────────────────────────────────────────────────────────
    useEffect(() => {
        var KTDatatableRemoteDataDemo = (function () {
            var isInitialized = false;
            var instance = null;

            var resolveDataTableClass = function () {
                if (typeof window === 'undefined') return null;
                if (window.KTDataTable) return window.KTDataTable;
                if (window.KTUI && window.KTUI.KTDataTable) return window.KTUI.KTDataTable;
                return null;
            };

            var init = function () {
                var KTDataTable = resolveDataTableClass();
                if (!KTDataTable) { setTimeout(init, 100); return null; }
                if (isInitialized && instance) return instance;

                var datatableEl = document.getElementById('kt_datatable_remote_source');
                if (!datatableEl) return null;

                if (datatableEl.hasAttribute('data-kt-datatable-initialized')) {
                    if (typeof KTDataTable.getInstance === 'function') {
                        var oldInstance = KTDataTable.getInstance(datatableEl);
                        if (oldInstance && typeof oldInstance.dispose === 'function') oldInstance.dispose();
                    }
                    datatableEl.removeAttribute('data-kt-datatable-initialized');
                    if (datatableEl.instance) delete datatableEl.instance;
                }

                var datatable = new KTDataTable(datatableEl, {
                    apiEndpoint: GET_COLLECTION_AGGREGATE_DATA,
                    requestMethod: 'POST',
                    requestHeaders: {
                        Authorization: token,
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    mapRequest: function () {
                        const state = datatable?.getState?.() || {};
                        const pageIndex = (datatable?.getState?.().page ?? 1) - 1;
                        const pageSize = datatable?.getState?.().pageSize || 0;

                        return JSON.stringify({
                            query: state?.search || '',
                            collection: 'applicant',
                            searchableFields,
                            filter,
                            pageSize: pageIndex * pageSize,
                            format: 'json',
                            populate: [
                                {
                                    path: 'user',
                                    model: 'user',
                                    populate: [
                                        { path: 'location.provincial', model: 'administrative' },
                                        { path: 'location.district', model: 'district' },
                                        { path: 'location.constituency', model: 'constituency' }
                                    ]
                                },
                                {
                                    path: 'opportunity',
                                    model: 'opportunity',
                                    populate: [{ path: 'company', model: 'company' }]
                                },
                            ],
                            sort: { _id: -1 }
                        });
                    },
                    mapResponse: function (res) {
                        return {
                            data: res.data || [],
                            totalCount: res.total || 0,
                        };
                    },
                    columns: {
                        user: {
                            title: 'Name',
                            render: function (value) {
                                return value ? capitalize(value.name ?? '') : '—';
                            },
                        },
                        "user.gender": {
                            title: 'Gender',
                            render: function (value, row) {
                                return capitalize(row?.user?.gender) || '—';
                            }
                        },
                        status: {
                            title: 'Status',
                            render: function (value) {
                                const status = (value || 'pending').toLowerCase();

                                const color =
                                    status === 'approved' || status === 'accepted'
                                        ? 'success'
                                        : status === 'rejected'
                                            ? 'destructive'
                                            : 'secondary';

                                                        return `
                                    <span class="kt-badge kt-badge-${color}">
                                        ${capitalize(status)}
                                    </span>
                                `;
                            },
                        },
                        createdAt: {
                            title: 'Date',
                            render: function (value) {
                                return value ? moment(value).format('DD MMM YYYY') : '—';
                            },
                        },
                        _id: {
                            title: 'Action',
                            render: function (value, row) {
                                const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(row))));
                                return `
                                    <div class="kt-menu" data-kt-menu="true">
                                        <div class="kt-menu-item" data-kt-menu-item-offset="0, 10px" data-kt-menu-item-placement="bottom-start" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click">
                                            <button class="kt-menu-toggle kt-btn kt-btn-sm kt-btn-icon kt-btn-outline">
                                                <i class="ki-filled ki-dots-vertical text-lg"></i>
                                            </button>
                                            <div class="kt-menu-dropdown kt-menu-default w-full max-w-[200px]" data-kt-menu-dismiss="true">
                                                <div class="kt-menu-item">
                                                    <a class="kt-menu-link applicant-view-btn" href="#" data-row="${encoded}">
                                                        <span class="kt-menu-icon"><i class="ki-filled ki-eye"></i></span>
                                                        <span class="kt-menu-title">View</span>
                                                    </a>
                                                </div>
                                                <div class="kt-menu-item">
                                                    <a class="kt-menu-link" href="#">
                                                        <span class="kt-menu-icon"><i class="ki-filled ki-trash"></i></span>
                                                        <span class="kt-menu-title">Delete</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                `;
                            }
                        }
                    },
                    pageSize: 10
                });

                isInitialized = true;
                instance = datatable;
                datatableRef.current = datatable;
                return instance;
            };

            return { init: function () { return init(); } };
        })();

        function safeInitialize() {
            var element = document.getElementById('kt_datatable_remote_source');
            if (!element) return;
            var inst = KTDatatableRemoteDataDemo.init();
            if (inst) window.datatableInstance = inst;
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', safeInitialize, { once: true });
        } else {
            setTimeout(safeInitialize, 1);
        }
    }, [token]);

    // ─── Helpers ──────────────────────────────────────────────────────────────
    const InfoRow = ({ label, value }) => (
        value ? (
            <div className="flex flex-col gap-0.5">
                <span className="text-xs text-muted-foreground">{label}</span>
                <span className="text-sm font-medium text-mono">{value}</span>
            </div>
        ) : null
    );

    const opp = selected?.opportunity;
    const user = selected?.user;

    const hasDocuments = selected?.documents?.length > 0;
    const hasQuestionnaires = selected?.questionnaires?.length > 0;

    const reloadTable = () => {
        if (datatableRef.current && typeof datatableRef.current.reload === 'function') {
            datatableRef.current.reload();
        }
    };

    // ─── Render ───────────────────────────────────────────────────────────────
    return (
        <div>
            {/* Page Header */}
            <div className="kt-container-fixed">
                <div className="flex flex-wrap items-center lg:items-end justify-between gap-5 pb-7.5">
                    <div className="flex flex-col justify-center gap-2">
                        <h1 className="text-xl font-medium leading-none text-mono">Applicants</h1>
                        <div className="flex items-center gap-2 text-sm font-normal text-secondary-foreground">
                            Review and manage all applicants for this opportunity
                        </div>
                    </div>
                </div>
            </div>

            {/* Stats */}
            <div className="kt-container-fixed mb-10">
                <div className="grid grid-cols-3 gap-5 lg:gap-7.5 h-full items-stretch">
                    {[
                        { label: "Total Applicants", color: "text-primary", id: "total-count" },
                        { label: "Total Approved", color: "text-foreground", id: "total-approved" },
                        { label: "Total Rejected", color: "text-muted-foreground", id: "total-rejected" },
                    ].map((stat, i) => (
                        <div key={i} className="kt-card flex-col justify-between gap-6 h-full bg-cover bg-[right_top_-1.7rem] bg-no-repeat channel-stats-bg">
                            <i className={`ki-filled ki-users text-2xl ${stat.color} w-7 mt-4 ms-5`}></i>
                            <div className="flex flex-col gap-1 pb-4 px-5">
                                <span className="text-3xl font-semibold text-mono" id={stat.id}>0</span>
                                <span className="text-sm font-normal text-secondary-foreground">{stat.label}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Table */}
            <div className="kt-container-fixed">
                <div className="kt-card mb-10">
                    <div className="kt-card-header">
                        <select className="kt-select w-36" data-kt-select="true" data-kt-select-placeholder="Select Status" name="kt-select" onChange={(e) => {
                            filter = {"status": e.target.value};
                            e.target.value === 'all' ? delete filter.status : Object.assign(filter, {status: e.target.value});
                            reloadTable();
                        }}>
                            <option value="all">
                                All Status
                            </option>
                            <option value="accepted">
                                Approved
                            </option>
                            <option value="rejected">
                                Rejected
                            </option>
                        </select>
                        <div className="kt-input max-w-48">
                            <i className="ki-filled ki-magnifier"></i>
                            <input type="text" placeholder="Search..." className="kt-input sm:w-48" data-kt-datatable-search="#kt_datatable_remote_source"/>
                        </div>
                    </div>
                    <div id="kt_datatable_remote_source" className="kt-card-table" data-kt-datatable-page-size="10"
                         data-kt-datatable-state-save="true">
                        <div className="kt-table-wrapper kt-scrollable">
                            <table className="kt-table" data-kt-datatable-table="true">
                                <thead>
                                <tr>
                                    <th scope="col" className="w-30" data-kt-datatable-column="user"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Name</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-30" data-kt-datatable-column="user.gender"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Gender</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-30" data-kt-datatable-column="status"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Status</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-30" data-kt-datatable-column="createdAt"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Date</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-24" data-kt-datatable-column="_id"><span
                                        className="kt-table-col"><span
                                        className="kt-table-col-label">Action</span></span></th>
                                </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                        <div className="kt-datatable-toolbar">
                            <div className="kt-datatable-length">Show <select className="kt-select kt-select-sm w-16"
                                                                              name="perpage"
                                                                              data-kt-datatable-size="true"></select> per
                                page
                            </div>
                            <div className="kt-datatable-info">
                                <span data-kt-datatable-info="true"></span>
                                <div className="kt-datatable-pagination" data-kt-datatable-pagination="true"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── View Modal ── */}
            <div className="kt-modal" data-kt-modal="true" id="view-modal">
                <div className="kt-modal-content max-w-[850px] top-[2%]">

                    {/* Modal Header */}
                    <div className="kt-modal-header">
                        <div className="flex items-center gap-3">
                            {/* Avatar */}
                            <div
                                className="shrink-0 size-10 rounded-full bg-primary/10 flex items-center justify-center">
                                <i className="ki-filled ki-user text-primary text-lg"></i>
                            </div>
                            <div>
                                <h3 className="kt-modal-title">{capitalize(user?.name) || 'Applicant'}</h3>
                                <p className="text-sm text-secondary-foreground">
                                    Applied {selected ? moment(selected.createdAt).format('DD MMM YYYY') : '—'}
                                    {opp?.position || opp?.title ? ` · ${opp.position ?? opp.title}` : ''}
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            {/* Status badge in header */}
                            {selected && (
                                <span className={`kt-badge ${
                                    selected.status === 'approved' ? 'kt-badge-success'
                                        : selected.status === 'rejected' ? 'kt-badge-danger'
                                            : 'kt-badge-warning'
                                }`}>
                                    {capitalize(selected.status ?? 'Applied')}
                                </span>
                            )}
                            <button type="button" className="kt-modal-close" onClick={closeViewModal}>
                                <i className="ki-filled ki-cross text-lg"></i>
                            </button>
                        </div>
                    </div>

                    {/* Modal Body with Tabs */}
                    <div className="kt-modal-body p-0">
                        {selected && (
                            <div>
                                {/* ── KTTabs Nav ── */}
                                <div
                                    className="kt-tabs kt-tabs-line px-5 border-b border-border"
                                    data-kt-tabs="true"
                                    id="applicant-modal-tabs"
                                >
                                    <button
                                        className="kt-tab-toggle active"
                                        data-kt-tab-toggle="#tab_applicant"
                                    >
                                        <i className="ki-filled ki-user text-sm"></i>
                                        Applicant
                                    </button>
                                    <button
                                        className="kt-tab-toggle"
                                        data-kt-tab-toggle="#tab_opportunity"
                                    >
                                        <i className="ki-filled ki-briefcase text-sm"></i>
                                        Opportunity
                                    </button>
                                    {hasDocuments && (
                                        <button
                                            className="kt-tab-toggle"
                                            data-kt-tab-toggle="#tab_documents"
                                        >
                                            <i className="ki-filled ki-document text-sm"></i>
                                            Documents
                                            <span className="kt-badge kt-badge-sm kt-badge-primary ml-1">{selected.documents.length}</span>
                                        </button>
                                    )}
                                    {hasQuestionnaires && (
                                        <button
                                            className="kt-tab-toggle"
                                            data-kt-tab-toggle="#tab_questionnaire"
                                        >
                                            <i className="ki-filled ki-questionnaire-tablet text-sm"></i>
                                            Answers
                                            <span className="kt-badge kt-badge-sm kt-badge-primary ml-1">{selected.questionnaires.length}</span>
                                        </button>
                                    )}
                                </div>

                                {/* ── Tab Content ── */}
                                <div className="p-5">

                                    {/* Tab 1 — Applicant */}
                                    <div id="tab_applicant">
                                        <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                                            <InfoRow label="Full Name" value={capitalize(user?.name)} />
                                            <InfoRow label="Gender" value={capitalize(user?.gender)} />
                                            <InfoRow label="Email Address" value={user?.email} />
                                            <InfoRow label="Mobile Number" value={user?.mobile_number ? String(user.mobile_number) : null} />
                                            <InfoRow label="Date of Birth" value={user?.dob ? moment(user.dob).format('DD MMM YYYY') : null} />
                                            <InfoRow label="Province" value={capitalize(user?.location?.provincial?.name)} />
                                            <InfoRow label="District" value={capitalize(user?.location?.district?.name)} />
                                            <InfoRow label="Constituency" value={capitalize(user?.location?.constituency?.name)} />
                                        </div>

                                        {/* CV link if available */}
                                        {user?.qualification?.document?.uri && (
                                            <div className="mt-4 pt-4 border-t border-border">
                                                <span className="text-xs text-muted-foreground block mb-2">CV / Resume</span>

                                                <a href={user.qualification.document.uri}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="kt-btn kt-btn-sm kt-btn-outline"
                                                >
                                                <i className="ki-filled ki-exit-up text-sm"></i>
                                                View CV
                                            </a>
                                            </div>
                                            )}
                                    </div>

                                    {/* Tab 2 — Opportunity */}
                                    <div id="tab_opportunity" className="hidden">
                                        {opp ? (
                                            <div className="flex flex-col gap-5">
                                                <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                                                    <InfoRow label="Opportunity Name" value={opp.position ?? opp.title} />
                                                    <InfoRow label="Type" value={capitalize(opp.type)} />
                                                    <InfoRow label="Company" value={opp.company?.name ?? opp.company?.company} />
                                                    <InfoRow label="Location" value={opp.location} />
                                                    <InfoRow label="Opening Date" value={opp.openingDate ? moment(opp.openingDate).format('DD MMM YYYY') : null} />
                                                    <InfoRow label="Closing Date" value={opp.closingDate ? moment(opp.closingDate).format('DD MMM YYYY') : null} />
                                                    <InfoRow label="Results Date" value={opp.resultDate ? moment(opp.resultDate).format('DD MMM YYYY') : null} />
                                                </div>
                                                {opp.description && (
                                                    <div className="flex flex-col gap-1 pt-4 border-t border-border">
                                                        <span className="text-xs text-muted-foreground">Description</span>
                                                        <p className="text-sm text-mono leading-relaxed whitespace-pre-line">{opp.description}</p>
                                                    </div>
                                                )}
                                                {opp.qualifications && (
                                                    <div className="flex flex-col gap-1 pt-4 border-t border-border">
                                                        <span className="text-xs text-muted-foreground">Qualifications</span>
                                                        <p className="text-sm text-mono leading-relaxed whitespace-pre-line">{opp.qualifications}</p>
                                                    </div>
                                                )}
                                                {opp.experience && (
                                                    <div className="flex flex-col gap-1 pt-4 border-t border-border">
                                                        <span className="text-xs text-muted-foreground">Experience</span>
                                                        <p className="text-sm text-mono leading-relaxed whitespace-pre-line">{opp.experience}</p>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <p className="text-sm text-muted-foreground">No opportunity details available.</p>
                                        )}
                                    </div>

                                    {/* Tab 3 — Documents */}
                                    {hasDocuments && (
                                        <div id="tab_documents" className="hidden">
                                            <div className="flex flex-col gap-3">
                                                {selected.documents.map((doc, i) => (
                                                    <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-border bg-muted/20">
                                                        <div className="flex items-center gap-3">
                                                            <div className="size-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                                                                <i className="ki-filled ki-document text-primary text-base"></i>
                                                            </div>
                                                            <div className="flex flex-col gap-0.5">
                                                                <span className="text-sm font-medium text-mono">{doc.field}</span>
                                                                <span className="text-xs text-muted-foreground">PDF Document</span>
                                                            </div>
                                                        </div>
                                                        {doc.url ? (
                                                            <a href={doc.url} target="_blank" rel="noreferrer" className="kt-btn kt-btn-sm kt-btn-outline">
                                                                <i className="ki-filled ki-exit-up text-sm"></i>
                                                                Open
                                                            </a>
                                                        ) : (
                                                            <span className="text-xs text-muted-foreground">No file</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Tab 4 — Questionnaire Answers */}
                                    {hasQuestionnaires && (
                                        <div id="tab_questionnaire" className="hidden">
                                            <div className="flex flex-col gap-3">
                                                {selected.questionnaires.map((q, i) => (
                                                    <div key={i} className="flex flex-col gap-2 p-4 rounded-lg border border-border bg-muted/20">
                                                        <div className="flex items-start gap-2">
                                                            <span className="shrink-0 size-5 rounded-full bg-primary/10 flex items-center justify-center text-xs font-semibold text-primary mt-0.5">{i + 1}</span>
                                                            <span className="text-sm font-medium text-mono">{q.field}</span>
                                                        </div>
                                                        <p className="text-sm text-muted-foreground pl-7 leading-relaxed">
                                                            {q.answer || <span className="italic">No answer provided</span>}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* ── Modal Footer with Actions ── */}
                                <div className="flex items-center justify-between px-5 py-4 border-t border-border">
                                    <button type="button" className="kt-btn kt-btn-outline" onClick={closeViewModal}>
                                        Close
                                    </button>
                                    <div className="flex items-center gap-2">
                                        {selected.status !== 'rejected' && (
                                            <button type="button" className="kt-btn kt-btn-destructive kt-btn-sm" onClick={() => {
                                                const options = {
                                                    position: "top-right",
                                                    hideAfter: 0
                                                };

                                                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                                                let data = {
                                                    id: selected._id,
                                                    status: 'rejected'
                                                }

                                                applicant("put", data).then((result) => {
                                                    hide();
                                                    if(!result.error) {
                                                        closeViewModal();
                                                        reloadTable();
                                                        setReset(new Date().getTime())
                                                        cogoToast.success("Applicant successfully rejected.", {position: "top-right"});
                                                    }
                                                });
                                            }}>
                                                <i className="ki-filled ki-bandage text-sm"></i>
                                                Reject
                                            </button>
                                        )}
                                        {selected.status !== 'approved' && (
                                            <button type="button" className="kt-btn kt-btn-sm" style={{ backgroundColor: '#22c55e', color: '#fff' }} onClick={() => {
                                                const options = {
                                                    position: "top-right",
                                                    hideAfter: 0
                                                };

                                                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                                                let data = {
                                                    id: selected._id,
                                                    status: 'approved'
                                                }

                                                applicant("put", data).then((result) => {
                                                    hide();
                                                    if(!result.error) {
                                                        closeViewModal();
                                                        reloadTable();
                                                        setReset(new Date().getTime())
                                                        cogoToast.success("Applicant successfully approved.", {position: "top-right"});
                                                    }
                                                });
                                            }}>
                                                <i className="ki-filled ki-check text-sm"></i>
                                                Approve
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Applicant;
